﻿import { IIncidentDocumentDeleteDialogProps } from "./IncidentDocumentDeleteDialog";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { createElement } from "react";
import { Trans } from "react-i18next";
import { deleteHttp } from "../../../../common/api/apiShared";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export function useIncidentDocumentDeleteDialog(props: IIncidentDocumentDeleteDialogProps) {
    const snackbar = useDotLegalSnackbar();

    const deleteMutation = useDotLegalMutation(deleteDocument);
    const deleteDocumentClick = (documentId: string) => {
        deleteMutation.mutateAsync(documentId!, {
            onSuccess: () => {
                props.onCloseDialog();
                props.onDeletedDocument();
                snackbar.show(createElement(Trans, { i18nKey: "documentDeleted", values: { document: props.selectedDocument!.name } }));
            },
        });
    };

    function deleteDocument(documentId: string) {
        return deleteHttp<string>(`/incidentLogEntry/${props.incidentLogId}/document/${documentId}`);
    }

    return {
        deleteDocumentClick,
        inProgress: deleteMutation.isLoading,
    };
}
